require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-code-fellows-is-coming-to-chicago.json") })
        }
      }, "path---blog-code-fellows-is-coming-to-chicago");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-code-fellows-is-coming-to-chicago!./.cache/json/blog-code-fellows-is-coming-to-chicago.json
// module id = 777
// module chunks = 231608221292675